import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-635c42e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = { class: "navbar navbar-expand" }
const _hoisted_3 = { class: "navbar-left" }
const _hoisted_4 = { class: "navbar-right" }
const _hoisted_5 = {
  key: 0,
  class: "sub-header"
}


export default /*#__PURE__*/_defineComponent({
  name: 'PageHeader',
  props: {
  hasSubHeader: Boolean,
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "header-content-left")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "header-content-right")
        ])
      ]),
      (__props.hasSubHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "sub-header-content")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})